<template>
  <div class="y-container">
    <slot />
  </div>
</template>

<style scoped>
.y-container {
  width: 1080px;
  margin: 0 auto;
  position: relative;
}
</style>
